/** Coerce API placeholder values for string replacement; formatting is done by the API */
export function formatToString(value: string | number): string {
  return typeof value === 'string' ? value : String(value)
}
